const styles = theme => ({
  actionsBtnContainer: {
    margin: '1em 0',
    gridTemplateAreas: '"1 1"',
    '& button': {
      borderRadius: '4px',
      textTransform: 'capitalize',
      fontWeight: 600,
      fontSize: '16px',
      padding: '16px 40px',
      width: '100%',
      whiteSpace: 'nowrap',
      borderColor: theme.palette.primary.adgmBlack,
    },
  },
  adgmRedBtn: {
    background: theme.palette.primary.main,
  },
  modalTitle: {
    fontSize: '18px',
    fontWeight: '600',
    lineHeight: '150%',
    marginBottom: '24px',
  },
  emojiTxt: {
    textAlign: 'center',
    marginTop: '8px',
  },
  crossIconImg: {
    width: '16px',
    height: '16px',
    cursor: 'pointer',
  },
  fontW500: {
    fontWeight: '500',
  },
  emojiCls: {
    cursor: 'pointer',
  },
  happyMeterModal: {
    maxWidth: '415px',
    padding: '24px',
  },
});
export default styles;
